import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUIControlsStore } from '../redux/features/ui-controls';
import { useAuthStore } from '../redux';

const SessionExpiredModal = () => {
  const navigate = useNavigate();

  const { showSessionExpiredModal, updateShowSessionExpiredModal } =
    useUIControlsStore();
  const { customerId, customerRefNum, Authorization } = useAuthStore();

  const yesButtonClicked = () => {
    updateShowSessionExpiredModal(false);
    navigate('/SignUp');
  };

  useEffect(() => {
    if (customerId && customerRefNum && Authorization) {
      updateShowSessionExpiredModal(false);
    } else {
      // updateShowSessionExpiredModal(true);
      window.location.assign('/');
    }
  }, [customerId, customerRefNum, Authorization]);

  return (
    <>
      {showSessionExpiredModal ? (
        <>
          <div
            className="res150-overlay fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-100 flex flex-col items-center justify-center p-2"
            style={{ background: 'rgb(0,0,0,0.8)', zIndex: 50 }}
          >
            <div className="bg-white rounded-lg flex flex-col m-auto p-3">
              {' '}
              <div className="max-w-[300px] text-center w-full flex flex-col justify-center items-center p-3">
                <p className="font-bold">Session Expired</p>
                <br />
                <p className="font-normal">
                  User session expired, Please login again
                </p>
              </div>
              <div className="flex flex-row justify-center items-center">
                <button
                  style={{
                    background: '#079F9F',
                    border: '1px solid #079F9F',
                    color: '#fff',
                    borderRadius: '5px',
                  }}
                  className="bg-whitetext-white inline-block m-1 px-2 py-2  rounded-lg text-sm font-semibold focus:outline-none tracking-wider transition duration-200 ease-in-out w-full "
                  onClick={yesButtonClicked}
                >
                  Okay, Got it
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default SessionExpiredModal;
